import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  width: string;
  height: string;
  text: string;
  onClick: () => void;
  sx?: any;
  disabled?: boolean;
}

export const ContainedYellowButton: React.FC<Props> = ({
  width,
  height,
  text,
  onClick,
  sx,
  disabled,
}) => {
  return (
    <PrimaryButton
      style={sx}
      width={width}
      height={height}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </PrimaryButton>
  );
};

interface PrimaryButtonProps {
  width: string;
  height: string;
  disabled?: boolean;
}

const PrimaryButton = styled.button<PrimaryButtonProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background: ${(props) =>
    props.disabled
      ? theme.palette.primitives.gray200
      : theme.palette.primitives.yellow400};
  border: ${(props) =>
    props.disabled
      ? `none`
      : `1px solid ${theme.palette.primitives.yellow400}`};
  border-radius: 4px;
  padding: 1rem 1.5rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.188rem;
  color: ${theme.palette.primitives.black};
  cursor: ${(props) => (props.disabled ? `not-allowed` : `pointer`)};
`;
